<template>
  <ok-modal
    :value="value"
    size="lg"
    dialog-class="tables-modal"
    :title="$t('page.enable-post-likes')"
    @change="$emit('input',false)"
  >
    <validation-observer ref="form">
      <error-alert
        v-if="error"
        :error="error"
      />
      <FetchingDataSpinner
        :loading="fetching"
        :loading-title="$t('page.get-feature-info')"
      />
      <b-row
        v-if="!fetching"
        class="justify-content-center"
      >
        <b-col
          md="8"
          sm="12"
        >
          <p>{{ $t('page.likes-feature-hint') }}</p>
        </b-col>
        <b-col
          v-if="exist>0"
          md="8"
          sm="12"
        >
          <b-alert
            variant="warning"
            class="error-alert"
            :show="true"
            :dismissible="false"
          >
            <slot name="title">
              <div class="font-weight-bold">
                {{ $t('page.likes-previous-enabled',[exist]) }}
              </div>
            </slot>
          </b-alert>
        </b-col>
        <b-col
          md="8"
          sm="12"
        >
          <ok-text-input
            v-model="form.count"
            is-required
            rules="positive|integer"
            :label="$t('page.likes-input-label')"
          />
        </b-col>
      </b-row>
    </validation-observer>
    <template #actions>
      <div class="d-flex justify-content-end align-items-center">
        <b-button
          variant="outline-dark"
          :disabled="loading"
          @click="submit"
        >
          <b-spinner
            v-if="loading"
            small
            class="ml-1"
          />
          {{ $t('forms.submit') }}
        </b-button>
        <b-button
          variant="dark"
          class="ml-1"
          @click="$emit('input',false)"
        >
          {{ $t('forms.cancel') }}
        </b-button>
      </div>
    </template>
  </ok-modal>
</template>

<script>
import {
  BButton, BRow, BCol, BSpinner, BAlert,
} from 'bootstrap-vue'
import OkModal from '@/@bya3/components/modals/OkModal'
import OkTextInput from '@/@bya3/components/inputs/OkTextInput'
import ErrorAlert from '@/@bya3/components/alerts/ErrorAlert'
import { ValidationObserver } from 'vee-validate'
import FeaturesApi from '@/api/features'
import { mapGetters } from 'vuex'
import FetchingDataSpinner from '@/@bya3/components/utils/FetchingDataSpinner.vue'

export default {
  name: 'LikesFeatureModal',
  components: {
    FetchingDataSpinner,
    BAlert,
    ErrorAlert,
    OkTextInput,
    ValidationObserver,
    OkModal,
    BButton,
    BRow,
    BCol,
    BSpinner,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    post: {
      type: Object,
      default: () => ({}),
    },
    postId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      error: null,
      form: {
        count: 1,
      },
      loading: false,
      fetching: true,
      limit: 0,
      exist: 0,
    }
  },
  computed: {
    ...mapGetters({
      currentPageId: 'pages/currentPageId',
    }),
  },
  watch: {
    postId() {
      this.fetching = true
      this.fetchLikesCount()
    },
  },
  methods: {
    async fetchLikesCount() {
      await FeaturesApi.checkLikesCount(this.currentPageId, this.postId).then(res => {
        if (res?.error === 1) {
          this.error = res?.message ?? ''
          this.$notifyError(this.error)
        } else {
          this.limit = res.count
          this.exist = res?.exist ?? 0
        }
      }).catch(e => { this.error = e })
        .finally(() => { this.fetching = false })
    },
    async submit() {
      this.error = null
      const valid = await this.$refs.form.validate()
      if (!valid) {
        this.error = this.$tc('errors.field-invalid', 2)
        this.notifyError = this.$tc('errors.field-invalid', 2)
      } else {
        this.loading = true
        const form = { ...this.form }
        form.post_id = this.post.id
        form.page_id = this.currentPageId
        form.post_text = this.post.form ?? ''
        await FeaturesApi.enablePostLikes(form).then(res => {
          if (res.error === 0) {
            this.$swal({
              position: 'center',
              icon: 'success',
              html: res.message,
              showConfirmButton: true,
              showCancelButton: false,
            })
            this.exist = this.form.count
            this.form = { count: 0 }
            this.$emit('input', false)
          }
        }).catch(e => { this.error = e })
          .finally(() => { this.loading = false })
      }
    },
  },
}
</script>
